import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, LazyModule, registerLazyOrchestrator } from "owa-bundling";
import { onOpenPersonSources, onPersonSourcesInternal } from "owa-nova-actions";
import { getStore } from "./store/store";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "OwaNovaPersonSources" */ "./lazyIndex"), { name: "OwaNovaPersonSources" });

registerLazyOrchestrator(onOpenPersonSources, lazyModule, m => m.openPersonSources);
registerLazyOrchestrator(onPersonSourcesInternal, lazyModule, m => m.personSourcesInternal);

export const PersonSourcesAsync: typeof lazyIndex.PersonSourcesWrapper = createLazyComponent(lazyModule, m => m.PersonSourcesWrapper, undefined, undefined, {
    onlyImportIf: () => getStore().isVisible,
});
